import {
  Injector,
  Pipe,
  PipeTransform
} from '@angular/core';
import {EmailAddress} from '../interface/email-address';
import {PhoneNumber} from '../interface/phone-number';


@Pipe({
  name: 'primaryContact'
})
export class PrimaryContactPipe implements PipeTransform {

  public constructor(private injector: Injector) {
  }

  transform(value: any): any {
    return value.filter((el: EmailAddress|PhoneNumber) => el.type.key === 'primary');
  }
}
